export default ({ children, test }) => (test ? children : null);
